import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import moment from "moment";
import Datepicker from 'vue3-datepicker'
import Maska from 'maska'



createApp(App)
.use(store)
.use(router)
.use(moment)
.use(Datepicker)
.use(Maska)
.mount('#app')
